export default __webpack_public_path__ + "images/56a15f86d7a5d4b208335265bf7648e7.svg";